import { render } from "./HeadingBlock.vue?vue&type=template&id=4bc806be&scoped=true"
const script = {}

import "./HeadingBlock.vue?vue&type=style&index=0&id=4bc806be&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc806be"]])

export default __exports__